/**
 * Icon map — permite referenciar iconos Ant desde los datos JSON/TS
 * del manual (donde no se puede importar JSX). Nuevas claves aquí,
 * uso desde datos vía `icon: "book"`.
 */

import type React from "react";
import {
  AuditOutlined,
  BookOutlined,
  GlobalOutlined,
  NotificationOutlined,
  QuestionCircleOutlined,
  ReadOutlined,
  SafetyOutlined,
  ShoppingOutlined,
  TeamOutlined,
  VideoCameraOutlined,
} from "@ant-design/icons";

export const iconMap: Record<string, React.ReactNode> = {
  book: <BookOutlined />,
  team: <TeamOutlined />,
  audit: <AuditOutlined />,
  safety: <SafetyOutlined />,
  global: <GlobalOutlined />,
  notification: <NotificationOutlined />,
  shopping: <ShoppingOutlined />,
  video: <VideoCameraOutlined />,
  faq: <QuestionCircleOutlined />,
  read: <ReadOutlined />,
};

export function getIcon(slug: string): React.ReactNode {
  return iconMap[slug] ?? <ReadOutlined />;
}
